<p>mb-checkout-payment-invoice-partial works!</p>
